import { useState, useEffect } from 'react';
import {
  Footprints, Shirt, Gem, LayoutGrid, ShoppingBag, Tag, Package,
  Watch, Glasses, Dumbbell, Trophy, Star, Heart, Zap, Crown,
  Layers, Umbrella, Briefcase, Sparkles, type LucideIcon,
} from 'lucide-react';

const ICON_MAP: Record<string, LucideIcon> = {
  Footprints, Shirt, Gem, LayoutGrid, ShoppingBag, Tag, Package,
  Watch, Glasses, Dumbbell, Trophy, Star, Heart, Zap, Crown,
  Layers, Umbrella, Briefcase, Sparkles,
};

export function getIcon(name: string | null | undefined): LucideIcon {
  return (name && ICON_MAP[name]) ? ICON_MAP[name] : Tag;
}

export interface FrontendCategory {
  name: string;
  description: string;
  Icon: LucideIcon;
}

const FALLBACK: FrontendCategory[] = [
  { name: 'Calzados',       description: 'Zapatillas y calzado urbano premium.',               Icon: Footprints },
  { name: 'Buzos y Tejidos',description: 'Buzos, hoodies y sweaters premium de punto.',         Icon: Shirt      },
  { name: 'Pantalones',     description: 'Pantalones sastreros y de vestir con calce perfecto.', Icon: Shirt      },
  { name: 'Remeras',        description: 'Remeras de algodón peinado de alta calidad.',          Icon: Shirt      },
  { name: 'Camperas',       description: 'Camperas de jean y parkas abrigadas.',                 Icon: Shirt      },
  { name: 'Accesorios',     description: 'Gorras, packs de medias y complementos.',              Icon: Gem        },
];

const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:8787';

export function useCategories() {
  const [categories, setCategories] = useState<FrontendCategory[]>(FALLBACK);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE}/api/v1/categories`)
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(res => {
        const items: { name: string; description: string | null; imageUrl: string | null }[] =
          res?.data ?? [];
        if (items.length > 0) {
          setCategories(items.map(c => ({
            name:        c.name,
            description: c.description ?? '',
            Icon:        getIcon(c.imageUrl),
          })));
        }
      })
      .catch(() => { /* mantiene fallback */ })
      .finally(() => setLoading(false));
  }, []);

  return { categories, loading };
}
